import React, { FunctionComponent } from 'react';
import { Container, Typography } from '@pwskills/rachnaui';
import { classNames } from '@pwskills/rachnaui/utils';
import OurServicesList from '@/utils/aboutUs/aboutUs.constants';

const AboutUs: FunctionComponent = () => {
  return (
    <>
      <Container className="py-8 regular:!py-14">
        <Typography
          component="h1"
          variant="bold"
          className="text-center text-gray-900 pb-9 regular:!pb-14"
        >
          About Us
        </Typography>
        <Typography
          component="body-regular"
          variant="regular"
          className="text-gray-850 text-center regular:!text-left pb-6"
        >
          PW Skills&apos; mission is to permeate through every student/professional&apos;s outlook
          towards jobs and change their attitude and perspective from &quot;How Can I Do It?&quot;
          to &quot;Of Course I Can Do It&quot;. We aim to do this by providing exceptional up
          skilling courses at affordable rates, while being tech-forward so anyone, anywhere can
          access and improve their ability to be successful in life.
        </Typography>
        <img src="/images/aboutUs/aboutUs.png" alt="about-us" className="w-full" />
      </Container>
      <div className="bg-blue-50">
        <Container className="py-8 regular:!py-14">
          <Typography
            component="h2"
            variant="bold"
            className="text-center font-inter pb-9 regular:!pb-14 text-gray-900"
          >
            Our Mission
          </Typography>
          <div className="flex flex-col large:!flex-row-reverse items-center space-y-3 regular:space-y-9">
            <img src="/images/aboutUs/complete-the-mission.svg" alt="about-us" className="px-12" />
            <Typography
              component="body-regular"
              variant="regular"
              className="text-gray-850 text-center regular:!text-left"
            >
              PW Skills is the result of a continual effort to exponentially increase the
              employability of every Indian, irrespective of their socioeconomic status. With
              accessibility and affordability being the support structure of high-quality,
              industry-relevant courses, PW Skills aims to empower professionals and students alike
              to either jumpstart their careers or leverage existing skills with new, future-driven
              upgrades that will help them realise their full potential.
            </Typography>
          </div>
        </Container>
      </div>
      <Container className="py-8 regular:!py-14">
        <Typography
          component="h2"
          variant="bold"
          className="text-center text-gray-900 pb-9 regular:!pb-14"
        >
          Our Services
        </Typography>
        <div className="flex flex-col regular:!flex-row flex-wrap gap-y-10">
          {OurServicesList.map((service, index) => (
            <div
              key={service.id}
              className={classNames(
                'regular:!basis-1/2 flex gap-x-4',
                index % 2 === 0 ? 'regular:!pr-7' : ''
              )}
            >
              <img
                src={service.imgLink}
                alt={service.title}
                className="w-12 h-12 regular:!w-[65px] regular:!h-[65px] large:!w-[95px] large:!h-[95px] pt-1 shrink-0"
              />
              <div>
                <Typography component="h4" variant="bold" className="font-inter text-gray-850">
                  {service.title}
                </Typography>
                <Typography
                  component="body-regular"
                  variant="regular"
                  className="text-gray-650 line-clamp-3 pt-[2px]"
                >
                  {service.description}
                </Typography>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </>
  );
};

export default AboutUs;
